<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <p class="imgItem1">ข้อตกลงความเป็นส่วนตัว</p>
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: `ยินดีต้อนรับสู่แอป Radon Bills ที่พัฒนาโดย Max Asset Management Company Limited เราให้ความสำคัญกับความเป็นส่วนตัวของคุณเป็นอย่างมากและมุ่งมั่นที่จะปกป้องข้อมูลส่วนบุคคลของคุณ ข้อตกลงความเป็นส่วนตัวนี้ออกแบบมาเพื่อช่วยให้คุณเข้าใจวิธีที่เรารวบรวม ใช้ จัดเก็บและปกป้องข้อมูลของคุณ เพื่อให้คุณได้รับประสบการณ์ที่ปลอดภัยและโปร่งใสเมื่อใช้ Radon Bills
เราเข้าใจดีว่าข้อมูลทางการเงินของคุณมีค่ามากสำหรับคุณ นั่นเป็นเหตุผลที่เราให้ความสำคัญสูงสุดคือการรักษาข้อมูลของผู้ใช้ให้ปลอดภัย นโยบายนี้อธิบายว่าข้อมูลส่วนบุคคลใดบ้างที่เรารวบรวมและจัดเก็บ และวิธีที่เราปกป้องข้อมูลส่วนบุคคลของคุณโดยการรักษาความลับ ความปลอดภัย และความเป็นส่วนตัว
1. เราจำกัดการรวบรวมและการใช้ข้อมูลส่วนบุคคลของคุณ
หลักการสำคัญที่เรายึดมั่นคือการจำกัดการรวบรวมและการใช้ข้อมูลส่วนบุคคลของคุณ ปรัชญาของเราคือ ยิ่งมีคนรู้จักคุณน้อยเท่าไร คุณก็ยิ่งปลอดภัยมากขึ้นเท่านั้น หากคุณใช้ Radon Bills เป็นไคลเอนต์โดยไม่มีการซิงโครไนซ์เซิร์ฟเวอร์ เราไม่สามารถเชื่อมโยงคุณกับใครก็ได้ และเราจะไม่รวบรวมชื่อ ที่อยู่ หรือรายละเอียดเครือข่ายโซเชียลของผู้ใช้ กล่าวโดยสรุป เราไม่มีข้อมูลใด ๆ ที่สามารถระบุถึงตัวคุณได้ เราจะไม่สามารถเข้าถึงข้อมูลในแอปของคุณจนกว่าคุณจะสร้างโปรไฟล์เซิร์ฟเวอร์ อย่างไรก็ตาม เมื่อใช้การซิงค์เซิร์ฟเวอร์ คุณจะต้องเชื่อมโยงข้อมูลของคุณกับที่อยู่อีเมลที่ระบุ เราไม่สามารถหลีกเลี่ยงสิ่งนี้ได้เนื่องจากเราจำเป็นต้องมอบความสามารถในการกู้คืนรหัสผ่านของคุณหากคุณลืม เราจะไม่ให้ที่อยู่อีเมลของคุณแก่บุคคลที่สามที่ไม่ผูกพันตามนโยบายนี้ แต่ขอย้ำอีกครั้ง โปรดคำนึงถึงระดับความเป็นส่วนตัวที่คุณต้องการเมื่อใช้การซิงค์เซิร์ฟเวอร์
อย่างไรก็ตาม เพื่อมอบประสบการณ์การใช้งานที่ดีขึ้น เราใช้บริการวิเคราะห์ภายนอกที่รวบรวมข้อมูลบางอย่างเกี่ยวกับผู้ใช้แต่ละราย เช่น วันที่และเวลาใช้งาน คุกกี้ ที่อยู่ IP ประเทศ เมือง ภาษาของอุปกรณ์ การทำงานของโทรศัพท์มือถือ ระบบและรุ่น และผู้ให้บริการมือถือ
 
เมื่อใช้ Radon Bills คุณต้องระบุข้อมูลส่วนบุคคลต่อไปนี้: ชื่อและยอดคงเหลือในกระเป๋าเงินและบัญชีของคุณ ชื่อแหล่งรายได้และงบประมาณของคุณ ประเภทการใช้จ่ายและเป้าหมาย การดำเนินการที่มีจำนวนเงิน บัญชี แหล่งที่มาของรายได้ หรือประเภทการใช้จ่าย วันที่ แท็ก และความคิดเห็น
การอนุญาตข้อมูลอุปกรณ์：เพื่อให้แน่ใจถึงการทำงานปกติของแอปพลิเคชัน Radon Bills เราอาจรวบรวมข้อมูลอุปกรณ์ รวมถึงรุ่นอุปกรณ์ ระบบปฏิบัติการ ตัวระบุอุปกรณ์ที่ไม่ซ้ำกัน ฯลฯ ข้อมูลนี้ช่วยให้เราปรับความเข้ากันได้ของแอปพลิเคชันให้เหมาะสม ปรับปรุงประสบการณ์ผู้ใช้ และรับประกันว่าแอปพลิเคชันทำงานได้อย่างราบรื่นบนอุปกรณ์ที่แตกต่างกัน
การเข้าถึงสมุดที่อยู่：เราอาจขอเข้าถึงสมุดที่อยู่ของคุณเพื่อให้คุณได้รับประสบการณ์การจัดการทางการเงินที่สะดวกยิ่งขึ้น เช่น การแชร์แผนงบประมาณกับผู้ติดต่อของคุณ หรือการสื่อสารกับที่ปรึกษาทางการเงินที่เชื่อถือได้ การอนุญาตนี้ใช้เพื่อเพิ่มประสิทธิภาพบริการส่วนบุคคลเท่านั้น และจะไม่ถูกนำมาใช้เพื่อวัตถุประสงค์อื่น
การอนุญาตกล้อง：แอปต้องได้รับอนุญาตจากกล้องเพื่อรองรับคุณสมบัติบางอย่าง เช่น การสแกนใบเสร็จรับเงินและตั๋วเพื่อเพิ่มรายการงบประมาณโดยอัตโนมัติ ข้อมูลกล้องจะไม่ถูกจัดเก็บหรือแชร์ ความปลอดภัยของข้อมูลของคุณคือสิ่งสำคัญที่สุดของเรา
การอนุญาตตำแหน่ง: ให้บริการทางการเงินส่วนบุคคลตามสถานที่ เราอาจขอตำแหน่งที่แน่นอนของคุณ เช่น เพื่อแสดงข้อมูลเกี่ยวกับธนาคารและตู้เอทีเอ็มใกล้คุณ ข้อมูลนี้ใช้เพื่อเพิ่มประสิทธิภาพบริการเท่านั้น และจะไม่ถูกนำมาใช้เพื่อวัตถุประสงค์อื่นใด
ปฏิทิน: เราอาจเข้าถึงปฏิทินของคุณได้ ใช้ในการสร้างและจัดการบิล แผนการเงิน ฯลฯ เพื่อช่วยให้คุณวางแผนการเงินส่วนบุคคลได้ดีขึ้น เราจะไม่เข้าถึงข้อมูลตารางเวลาอื่นๆ ของคุณ และจะไม่แก้ไขหรือแชร์เนื้อหาปฏิทินของคุณ
SMS: เราอาจได้รับอนุญาตทาง SMS คุณสามารถแชร์คำเชิญลิงค์ APP ของเราให้เพื่อนของคุณผ่านทาง SMS ได้ นอกจากนี้ เราจะไม่อ่านหรือแม้แต่เก็บรักษาเนื้อหาข้อมูลอื่นๆ ของคุณ
เมื่อคุณติดต่อฝ่ายสนับสนุนลูกค้า คุณอาจเลือกที่จะส่งข้อมูลส่วนบุคคลเกี่ยวกับปัญหาที่คุณกำลังประสบเมื่อใช้บริการ
หากคุณใช้ Radon Bills และแจ้งที่อยู่อีเมลของคุณแก่เรา คุณจะต้องยอมรับนโยบายความเป็นส่วนตัวเหล่านี้โดยชัดแจ้ง และให้สิทธิ์แก่เราในการรวบรวมและจัดเก็บข้อมูลส่วนบุคคลของคุณ คุณสามารถปฏิเสธที่จะทำเช่นนี้ได้ แต่น่าเสียดายที่คุณจะไม่สามารถใช้ Radon Bills ได้ เนื่องจากไม่มีประโยชน์หากไม่มีข้อมูลส่วนบุคคล
 
2. คุณคือผู้ควบคุมความปลอดภัยส่วนบุคคลของคุณ
เนื่องจากที่อยู่อีเมลเป็นเพียงลิงก์เดียวระหว่างชุดข้อมูลนามธรรมกับบุคลิกภาพของคุณ เราขอแนะนำอย่างยิ่งให้คุณใช้ที่อยู่อีเมลที่ไม่เชื่อมโยงกับบัญชีเครือข่ายโซเชียลของคุณหรือชื่อและนามสกุลของคุณ หากคุณตัดสินใจที่จะใช้ที่อยู่อีเมลหลักของคุณ โปรดเก็บที่อยู่อีเมลนั้น รหัสผ่านของคุณ และข้อเท็จจริงที่เกี่ยวข้องกับบัญชี Radon Bills ไว้เป็นความลับ เราขอแนะนำให้คุณลบอีเมลต้อนรับที่เราส่งให้คุณหลังจากอ่านแล้ว และไม่ควรให้ข้อมูลประจำตัวแก่บุคคลที่สามไม่ว่าในกรณีใด หากคุณสงสัยว่าข้อมูลประจำตัวของคุณได้มาอย่างผิดกฎหมาย โปรดเปลี่ยนรหัสผ่านของคุณภายในแอปพลิเคชันทันที เราจะไม่รับผิดชอบหากมีบุคคลอื่นเข้าถึงโปรไฟล์เซิร์ฟเวอร์ของคุณผ่านข้อมูลการลงทะเบียนที่ได้รับจากคุณ
คุณสามารถเลือกที่จะไม่ระบุที่อยู่อีเมลของคุณและยังคงสามารถเข้าถึงคุณลักษณะทั้งหมดที่นำเสนอโดย Radon Bills รวมถึงคุณลักษณะขั้นสูง ยกเว้นการซิงโครไนซ์กับเซิร์ฟเวอร์และระหว่างอุปกรณ์ต่างๆ (เนื่องจากอีเมลเป็นตัวระบุที่ไม่ซ้ำกันสำหรับการซิงโครไนซ์นี้)
 
3. วิธีที่เราใช้ข้อมูลส่วนบุคคลของคุณ
เราใช้ข้อมูลส่วนบุคคลทั้งหมดของคุณเป็นการภายในเพื่อวัตถุประสงค์ดังต่อไปนี้เท่านั้น:
- ให้บริการพื้นฐานเพื่อวิเคราะห์สถานการณ์ทางการเงินส่วนบุคคลของคุณ
- แจ้งข่าวสาร ข้อมูลอัปเดต การแจ้งเตือน การแจ้งเตือนด้านผู้ดูแลระบบ และการแจ้งเตือนประเภทอื่นๆ แก่คุณ
- วิเคราะห์ข้อมูลทางสถิติและดำเนินการวิจัยเพื่อการพัฒนาผลิตภัณฑ์ การปรับปรุงบริการ และการทดสอบการทำงาน
วัดหรือทำความเข้าใจประสิทธิภาพของโฆษณาที่เราให้บริการแก่คุณและผู้อื่น และเพื่อให้โฆษณาที่เกี่ยวข้องแก่คุณ
ตรวจสอบบัญชีและกิจกรรม ติดตามกิจกรรมที่น่าสงสัยหรือฉ้อโกง และระบุการละเมิดข้อกำหนดการใช้งาน
- ให้การสนับสนุนลูกค้า
 
4. เรารับประกันความปลอดภัยและให้การเข้ารหัส
เราใช้ขั้นตอนการรักษาความปลอดภัยทางอิเล็กทรอนิกส์และทางกายภาพที่เหมาะสมทั้งหมดเพื่อปกป้องข้อมูลของคุณ เราจัดเก็บรหัสผ่านของคุณในรูปแบบที่เข้ารหัส ดังนั้นจึงไม่สามารถกู้คืนรหัสผ่านของคุณได้ด้วยวิธีการอื่นใด นอกเหนือจากขั้นตอนมาตรฐานในการกู้คืนรหัสผ่านของคุณผ่านที่อยู่อีเมลของคุณ
 
5. คุณสามารถลบข้อมูลส่วนบุคคลของคุณได้
คุณมีสิทธิ์ที่จะลบบัญชีของเขาและ/หรือปฏิเสธที่จะใช้ Radon Bills ได้ตลอดเวลา ในการดำเนินการนี้ คุณควรติดต่อฝ่ายสนับสนุนลูกค้าของ Radon Bills ทางอีเมลที่ market@radonkritcompany.com คุณควรเขียนอีเมลนี้จากที่อยู่อีเมลเดียวกันกับที่ลงทะเบียนไว้ในบัญชีที่คุณต้องการลบ เราอาจขอให้คุณให้ข้อมูลเพิ่มเติมเพื่อยืนยันตัวตนของคุณ หลังจากนั้นเราจะลบข้อมูลส่วนบุคคลของคุณทั้งหมดอย่างสมบูรณ์
 
6. คุณสามารถดึงข้อมูลส่วนบุคคลของคุณได้
คุณมีสิทธิ์ส่งออกข้อมูลของคุณจาก Radon Bills ได้ตลอดเวลา คุณสามารถทำได้ในส่วนการตั้งค่า -> ส่งออกในแอป Radon Bills หรือโดยการร้องขอไปยังฝ่ายสนับสนุนลูกค้าผ่านทางอีเมลที่ market@radonkritcompany.com คุณควรเขียนอีเมลนี้โดยใช้ที่อยู่อีเมลเดียวกับที่ลงทะเบียนบัญชีที่คุณต้องการลบ เราอาจขอให้คุณให้ข้อมูลเพิ่มเติมเพื่อยืนยันตัวตนของคุณ คุณจะได้รับไฟล์ส่งออกในรูปแบบ CSV ไปยังอีเมลของคุณ
 
7. การปรับปรุงนโยบายความเป็นส่วนตัว
หากสถานการณ์เปลี่ยนแปลง เราอาจปรับปรุงนโยบายความเป็นส่วนตัวนี้ วันที่แก้ไขกรมธรรม์จะอยู่ที่ด้านบนของหน้าเสมอ การเปลี่ยนแปลงมีผลทันทีเมื่อโพสต์
 
8. หากคุณต้องการเรา เราพร้อมให้บริการคุณ
หากคุณมีคำถามใด ๆ เกี่ยวกับการรักษาความปลอดภัยของข้อมูลและการประมวลผลข้อมูลส่วนบุคคล โปรดติดต่อ admin@maxassetcompany.com
เว็บไซต์อย่างเป็นทางการ: http://www.maxassetcompany.com
ชื่อบริษัท: Max Asset Management Company Limited
ที่อยู่บริษัท: 36/51 หมู่ที่ 2 ตำบลเกาะแก้ว อำเภอเมืองภูเก็ต จ.ภูเก็ต 83000
โทร: +66 6651587476`,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};

</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3700px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  transform: scale(90%);
  /* transform: scale(80%); */
  margin: -150px auto 100px;
  height: 2100px;
  /* box-shadow: 0 1px 4.8px 0px rgba(0, 0, 0, 0.25); */
  /* border: 2px solid #4D64E4; */
  border-radius: 36px;
  /* border-top: 1px solid #457b9d;
  border-bottom: 1px solid #457b9d; */
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 2px solid #4d64e4;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "Thonburi";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}
</style>
